// Filter the shared nightly US snapshot, never relabel a global shelf as a city.
export const guideCityInventoryPaths = Object.freeze({
  Miami: "/classic-car-rental-miami",
  "Las Vegas": "/classic-car-rental-lasvegas",
  "San Francisco": "/classic-car-rental-sanfrancisco",
  Austin: "/classic-car-rental-austin",
});
export function locationCars(cars, location) {
  if (!location) return cars;
  return cars.filter((car) => {
    const latitude = Number(car.latitude), longitude = Number(car.longitude);
    if (car.latitude != null && car.longitude != null && Number.isFinite(latitude) && Number.isFinite(longitude)) {
      const r = Math.PI / 180;
      const dLat = (latitude - location.latitude) * r;
      const dLon = (longitude - location.longitude) * r;
      const a = Math.sin(dLat / 2) ** 2 + Math.cos(latitude * r) *
        Math.cos(location.latitude * r) * Math.sin(dLon / 2) ** 2;
      return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)) <= 80;
    }
    return String(car.city || "").trim().toLowerCase() === location.city.toLowerCase();
  });
}